import styled from "@emotion/styled";

import { fontMerriweather } from "shared/lib/styles";

export const Container = styled.div`
  color: #001246;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  line-height: 140%;
`;

export const Title = styled.span`
  font-weight: 700;
  font-family: ${fontMerriweather};
`;
